var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFullSizeImageSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M11,4V2H5C3.3457031,2,2,3.3457031,2,5v6h2V5.4140625l7.2929688,7.2929688l1.4140625-1.4140625L5.4140625,4H11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28,26.5859375l-7.2929688-7.2929688l-1.4140625,1.4140625L26.5859375,28H21v2h6c1.6542969,0,3-1.3457031,3-3v-6h-2 V26.5859375z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27,2h-6v2h5.5859375l-7.2929688,7.2929688l1.4140625,1.4140625L28,5.4140625V11h2V5C30,3.3457031,28.6542969,2,27,2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2929688,19.2929688L4,26.5859375V21H2v6c0,1.6542969,1.3457031,3,3,3h6v-2H5.4140625l7.2929688-7.2929688 L11.2929688,19.2929688z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullSizeImageSmall);
export default __webpack_public_path__ + "static/media/full-size-image--small.ff8eb87c894380ee880fad446774ff10.svg";
export { ForwardRef as ReactComponent };